module.exports = __webpack_public_path__ + "static/media/fleetvehiclesIcon.705bd6b0.svg";